module.exports = __webpack_public_path__ + "img/logo.f812b818.png";